
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Guide complet pour créer un site web rentable",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Guide complet pour créer un site web rentable : Astuces et conseils pour succès en ligne.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Guide complet pour créer un site web rentable",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Guide complet pour créer un site web rentable : Astuces et conseils pour succès en ligne.",
        },
      ],
    };
  },
};
